"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = __importDefault(require("styled-components"));
const react_svg_1 = require("react-svg");
const react_1 = __importDefault(require("react"));
const master_1 = require("../../constants/master");
const StyledBaseSvg = styled_components_1.default.div `
  height: ${(props) => props.height}px;
  width: ${(props) => props.width}px;
  .customizable-icon .injected-svg {
    fill: ${(props) => props.primaryColor} !important;
    stroke: none;
  }

  .fill-stroke .injected-svg {
    stroke: ${(props) => props.primaryColor} !important;
  }
`;
function DynamicSvg(props) {
    return (react_1.default.createElement(StyledBaseSvg, { primaryColor: (0, master_1.getMasterConfig)().primaryColor, width: props.width, height: props.height },
        react_1.default.createElement(react_svg_1.ReactSVG, { wrapper: "svg", src: props.src, height: props.height, width: props.width, style: props.style, className: `customizable-icon ${props.fillStrokeWithPrimaryColor ? "fill-stroke" : ""} ${props.className || ""}` })));
}
exports.default = DynamicSvg;
